import type { AppLanguage } from "../lib/localePrefs";
import de from "./locales/de.json";
import en from "./locales/en.json";

type TranslationNode = string | { [key: string]: TranslationNode };

const resources: Record<AppLanguage, TranslationNode> = { de, en };

export function translate(
  lang: AppLanguage,
  key: string,
  vars?: Record<string, string | number>,
): string {
  const parts = key.split(".");
  let node: TranslationNode | undefined = resources[lang];
  for (const part of parts) {
    if (typeof node !== "object" || node == null) {
      node = undefined;
      break;
    }
    node = node[part];
  }

  let text = typeof node === "string" ? node : key;
  if (vars) {
    text = text.replace(/\{\{(\w+)\}\}/g, (_, name: string) =>
      String(vars[name] ?? ""),
    );
  }
  return text;
}
